export default "__VITE_ASSET__ClxTd1RJ__"